<template>
  <header class="navbar">
  	<div class="left">
  		<a href="#hero" v-scroll-to:-75><img src="@/assets/img/logo.png" class="logo" alt="Logo La Cité"></a>
  		<nav class="main-nav">
  			<a href="#campus" v-scroll-to:-50>Pourquoi La Cité</a>
  			<a href="#opportunites" v-scroll-to:-50>Opportunités</a>
  			<a href="#equipe" v-scroll-to:-20>Équipe</a>
  			<a href="#programmes" v-scroll-to:-150>Programmes</a>
  			<a href="#fonctionnement" v-scroll-to:-80>Fonctionnement</a>
  		</nav>
  	</div>
  	<div class="right">
  		<a href="#" class="cta" @click.prevent="setPanelIsOpen(true)">Planifiez un appel</a>
  	</div>
  </header>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('app', ['networkOnLine', 'appTitle', 'appShortTitle'])
  },
  methods: {
    ...mapActions('app', ['setPanelIsOpen'])
  }
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';
@import '@/theme/style.scss';

.navbar {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 4vw;
	background-color: #fff;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1000;

	.left {
		display: flex;
		align-items: center;

		.logo {
			width: 125px;
		}

		.main-nav {
			display: flex;
			align-items: center;

			a {
				font-family: $fontTexte;
				color: $dark-green;
				margin-left: 4vw;
				transition: all 0.2s ease;

				&:hover {
					color: $regular-green;
				}
			}
		}
	}

	@media screen and (max-width: 1050px) {
		.left {
			.main-nav {
				display: none;
			}
		}
	}

	@media screen and (max-width: 600px) {
		position: relative;
		.left {
			.logo {
				width: 100px;
			}
		}
	}
}

</style>
